<template>
    <LoadingButton
        :loading="loading"
        :disabled="disabled"
        class-name="px-6 h-10 rounded-lg whitespace-nowrap bg-branding-brand-yellow hover:bg-branding-mustard font-semibold text-branding-rich-black relative"
    >
        <slot />
    </LoadingButton>
</template>

<script lang="ts" setup>
    withDefaults(
        defineProps<{
            loading: boolean;
            disabled?: boolean;
        }>(),
        { loading: false, disabled: false }
    );
</script>
